import React from 'react';
import ScrollIntoView from 'scroll-into-view';
import { AUTO_SCROLL_DURATION, Section as SectionEnum } from 'components/navigation/subheader/SectionsNavigation';
import { useScreenBreakpoint } from 'consts/breakpoints';
import { MOBILE_HEADER_TOTAL_HEIGHT, MOBILE_SUBMENU_HEIGHT, DESKTOP_HEADER_TOTAL_HEIGHT } from 'components/navigation/header.constants';

function useScrollToPriceEstimation(cb?: () => void) {
  const breakpoint = useScreenBreakpoint();

  const isMobile = breakpoint <= 2;
  const mobileSubmenuHeight = isMobile
    ? MOBILE_HEADER_TOTAL_HEIGHT + MOBILE_SUBMENU_HEIGHT
    : DESKTOP_HEADER_TOTAL_HEIGHT;

  const scrollSettings = {
    time: AUTO_SCROLL_DURATION,
    align: {
      topOffset: mobileSubmenuHeight + 16,
      top: 0,
    },
  };


  return React.useCallback(() => {
    if (typeof cb === 'function') cb();
    const el = document.querySelector<HTMLElement>(`[data-scroll-into-view=${SectionEnum.PRICES_ESTIMATION}]`);
    if (el) {
      ScrollIntoView(el, scrollSettings);
    }
  }
  , [ cb ]);
}

export default useScrollToPriceEstimation;
